import axios from 'axios'
import { host } from '../../helper/config'
import { getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-loto-thudo-result'

export const getLotoThudoResults = async (token, query, page) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
    ...query,
    page,
    itemPerPage: getItemPerPage()
  }, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': token
    },
  })

  return response?.data || {}
}

export const upsertLotoThudoResult = async (token, payload) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/upsert-result`, payload, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': token
    },
  })

  return response?.data || {}
}

export const calculateLotoThudoReward = async (token, payload) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/calculate-reward`, payload, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'Authorization': token
    },
  })

  return response?.data || {}
}
